import React from 'react';
import {Table, Card, Button, Select, Typography, DatePicker, Tag, Modal, Space, Divider, Input} from "antd";
import {dpoReport, dpoReportSplits, dpoReportList, visualize,completeDPOReport} from '../api/api'
import moment from "moment";

export const DPOSelect = ({value,onChange})=>{

    const [dpo, setDpo] = React.useState([])

    const load = async ()=>{
        const {data:{rows = []}} = await visualize('po')
        setDpo(rows.map(({id, name})=>({id,name})))
    }

    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <Select showSearch optionFilterProp={'children'} placeholder="Select a DPO" style={{width: 400}} key={dpo} onChange={onChange} value={value}>
            {
                dpo.map(({id,name})=><Select.Option key={id} value={id}>{name}</Select.Option>)
            }
        </Select>
    </React.Fragment>
}


export const DPOReportView = (props)=>{

    const [dpo,setDpo] = React.useState()
    const [source, setSource] = React.useState([]);
    const [ci, setComplete] = React.useState({
        id:-1,
        visible:false,
        transfer_date: moment(),
        transaction_id: ''
    });

    const load = async ()=>{
        if(dpo) {
            const {data:{rows=[]}} = await dpoReportList({id:dpo})
            setSource(rows)
        }else
            setSource([])
    }

    React.useEffect(()=>{
        load();
    },[dpo])

    return <React.Fragment>
        <Card
            title={<DPOSelect value={dpo} onChange={e=>setDpo(e)}/>}
        >
            <Table
                dataSource={source}
                pagination={false}
                size={`small`}
            >
                <Table.Column dataIndex={'id'} title={''} render={(value,row,index)=>{

                    const {completed} = row;

                    return <Button size={'small'} disabled={completed} onClick={()=>{
                            setComplete({
                                id:value,
                                visible:true,
                                transfer_date: moment(),
                                transaction_id: ''
                            })
                        }}>Complete</Button>
                }}/>
                <Table.Column dataIndex={'id'} title={'Commission Report PDF'} render={(value, row, index) => {

                    const { effective_month, dpo_id } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await dpoReport(dpo_id, effective_month, 'pdf')
                        }}>Download PDF</Button>
                    </Space>;
                }} />
                <Table.Column dataIndex={'id'} title={'Commission Report CSV'} render={(value, row, index) => {

                    const { effective_month, dpo_id } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await dpoReport(dpo_id, effective_month, 'csv')
                        }}>Download CSV</Button>
                    </Space>;
                }} />
                <Table.Column dataIndex={'id'} title={'Handled Order Report'} render={(value, row, index) => {

                    const { effective_month, dpo_id } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await dpoReportSplits(dpo_id, effective_month)
                        }}>Download CSV</Button>
                    </Space>;
                }} />
                <Table.Column dataIndex={'due_in'} title={'Due In'} render={(value,row,index)=>{
                    return <Typography.Text>{moment(value).format('YYYY-MM-DD')}</Typography.Text>
                }}/>
                <Table.Column dataIndex={'duration'} title={'Duration'} render={(value,row,index)=>{
                    const data = value.split(",").map(o=>{
                        return o.match(/\d{4}-\d{2}-\d{2}/g) || "STARTED"
                    }).join(" - ")
                    return <Typography.Text>{data}</Typography.Text>
                }}/>
                <Table.Column dataIndex={'completed'} title={'Paid'} render={(value,row,index)=>{

                    return <Typography.Text>{value ? <Tag color={'green'}>PAID</Tag> : <Tag color={'red'}>PENDING</Tag>}</Typography.Text>
                }}/>
                <Table.Column dataIndex={'dpo_fee'} title={'Amount'} render={(value,row,index)=>{

                    return <Typography.Title style={{fontSize: 16}} level={6}>{`${(value || 0).toFixed(2) } €`}</Typography.Title>
                }}/>
                <Table.Column dataIndex={'transfer_date'} title={'Transfer Date'} render={(value,row,index)=>{
                    return <Typography.Text >{value ? moment(value).format('YYYY-MM-DD') : ""}</Typography.Text>
                }}/>
                <Table.Column dataIndex={'transaction_id'} title={'Payment ID'} />
            </Table>
        </Card>

        <Modal
            centered={true}
            closable={true}
            onCancel={()=>setComplete({
                id:-1,
                visible:false,
                transfer_date: moment(),
                transaction_id: ''
            })}
            visible={ci.visible}
            title={"Report : #" + `${ci.id || 0}`.padStart(4,'0')}
            onOk={async ()=>{
                const {visible, ...args} = ci;
                await completeDPOReport({...args})
                setComplete({
                    id:-1,
                    visible:false,
                    transfer_date: moment(),
                    transaction_id: ''
                })
                load()
            }}
        >
            <Space>
                <Typography.Text>Transfer Date</Typography.Text>
                <DatePicker value={ci.transfer_date} onChange={(date)=>{
                    setComplete({...ci, transfer_date: date})
                }}/>
                <Divider type={"vertical"}/>
                <Typography.Text>Payment ID</Typography.Text>
                <Input value={ci.transaction_id} onChange={(e)=>{
                    setComplete({...ci, transaction_id: e.target.value})
                }}/>
            </Space>
        </Modal>


    </React.Fragment>
}